module.exports = __webpack_public_path__ + "img/facts_1935.e74cf25e.jpg";